export enum EComplaintCommentState {    
    Readed,
    Unreded
}